import { useState } from 'react'
import { pictures } from './AnimalsPictures';
import paws from '../../../res/paws.png';
import Sidebar from '../../Sidebar/Sidebar';

import '../MemoryGames.css';

function InitialCard({ picture, isRevealed, revealCard }) {
  const firstCard = isRevealed ? picture : { src:paws, alt: 'Carte representant des traces de pas' }
    
    return (
      <div className='initialCard' onClick={() => revealCard()}>
        <img className='initialCard'src={firstCard.src} alt={firstCard.alt}/>
      </div>
    );
}
  
export default function MemoryColors() {
    const cards = pictures.map((picture) => ({picture, isRevealed: false}))
    const pairedCards = cards.concat(cards)
    const randomCards = pairedCards.sort(() => Math.random() - 0.5)
    const [ cardsInitialState, setCardsInitialState ] = useState(randomCards)
    const [ selectedCards, setSelectedCards ] = useState([])
    const [ blockedCard, setBlockedCard ] = useState(false)
  
    function revealCard(index) {
      if (blockedCard) {
        return
      }
  
      if (selectedCards.length === 0) {
        setSelectedCards([index])
      } else {
        if (selectedCards[0] === index) {
          return
        } else if (cardsInitialState[selectedCards[0]].picture.src === cardsInitialState[index].picture.src) {
          const nextCardsState = cardsInitialState.map(card => ({...card}))
  
          nextCardsState[index].isRevealed = true
          nextCardsState[selectedCards[0]].isRevealed = true
          
          setCardsInitialState(nextCardsState)
          setSelectedCards([])
        } else {
          setSelectedCards([selectedCards[0], index])
          setBlockedCard(true)
  
          const blockedTime = setInterval(() => {
            setSelectedCards([])
            setBlockedCard(false)
            clearInterval(blockedTime)          
          }, 700)
        }
      }
    }
  
    function Reset() {
      setCardsInitialState(randomCards);
      setSelectedCards ([]);
      setBlockedCard(false);
    }
  
    return (
      <section className='memory_global_section'>
        <div className='memory_main_section'>
          <h1 className="memory_game_title">Memory</h1>
          <h2 className="memory_game_subtitle">Animaux</h2>
          <p className='memory_game_rule'>Retrouve les paires dissimulées derrière les cartes.</p>
          <div className='cards'>
            {cardsInitialState.map((cards, index) => {
              return (
                <InitialCard 
                  value={index} 
                  picture={cards.picture} 
                  isRevealed={cards.isRevealed || selectedCards.includes(index)}
                  revealCard={() => revealCard(index)}
                />
              )
            })}      
          </div>
          <button className='memory_reset' onClick ={() => Reset()}>Recommencer</button>
        </div>
        <div>
          <Sidebar/>
        </div>
      </section>
    );
}
  
  
